<template>
	<div id="chart">
		<apexchart
			type="bar"
			height="280"
			:options="data.chartOptions"
			:series="data.series"
		></apexchart>
	</div>
</template>
<script>
	import { reactive } from "vue";
	import VueApexCharts from "vue3-apexcharts";
	import API from "@/config/api";
	import toast from "@/config/toast";

	export default {
		name: "MonthlyChartsApex",
		components: {
			apexchart: VueApexCharts,
		},

		setup: () => {
			const data = reactive({
				series: [
					{
						name: "Booked",
						data: [200, 250, 300, 400],
						color: "#09aeef",
					},
					{
						name: "Lost Lead",
						data: [50, 23, 20, 10],
						color: "#f77947",
					},
					{
						name: "Unqualified",
						data: [10, 17, 15, 5],
						color: "#b9b9b9",
					},
					{
						name: "Proposal Sent",
						data: [21, 7, 25, 13],
						color: "#39ce7f",
					},
					{
						name: "Working",
						data: [50, 10, 15, 70],
						color: "#39ceff",
					},
				],
				chartOptions: {
					chart: {
						type: "bar",
						height: 280,
						stacked: true,
						toolbar: {
							show: true,
						},
						zoom: {
							enabled: false,
						},
					},

					responsive: [
						{
							breakpoint: 480,
							options: {
								legend: {
									position: "bottom",
									offsetX: -10,
									offsetY: 0,
								},
							},
						},
					],
					plotOptions: {
						bar: {
							horizontal: false,
							borderRadius: 8,
							columnWidth: "25px",
						},
					},
					xaxis: {
						type: "category",
						categories: ["March", "April", "May", "June"],
					},
					legend: {
						position: "right",
						offsetY: 40,
					},
					fill: {
						opacity: 1,
					},
				},
			});

			const getChartStats = async () => {
				try {
					const response = await API.privateRequest.get("leads/stats/charts");
					const months = {
						1: "January",
						2: "February",
						3: "March",
						4: "April",
						5: "May",
						6: "June",
						7: "July",
						8: "August",
						9: "September",
						10: "October",
						11: "November",
						12: "December",
					};
					let categories = response.data.data
						.map((month) => month._id)
						.map((id) => months[id]);
					data.chartOptions = { ...data.chartOptions, xaxis: { type: 'category', categories: [...categories]} }
					data.series[0].data = response.data.data.map(
						(dataList) => dataList.list?.Booked || 0,
					);
					data.series[1].data = response.data.data.map(
						(dataList) => dataList.list?.Lost || 0,
					);
					data.series[2].data = response.data.data.map(
						(dataList) => dataList.list?.Unqualified || 0,
					);
					data.series[3].data = response.data.data.map(
						(dataList) => dataList.list["Proposal Sent"] || 0,
					);
					data.series[4].data = response.data.data.map(
						(dataList) => dataList.list?.Working || 0,
					);
				} catch (err) {
					let message;
					console.log(err);
					if (err?.response?.status < 500 && err?.response?.status >= 400) {
						message = err.response.data.message;
					} else if (err?.response?.status >= 500) {
						message = "Oops! something went wrong";
					} else {
						message = "App Error";
					}

					toast.error(message, true);
				}
			};

			getChartStats();

			return {
				data,
			};
		},
	};
</script>

<style scoped>
	#chart {
		height: 300px;
	}
</style>